import Barcode from 'react-barcode';
const BarCode = ({ id }) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  return (
    <Barcode value={`${companyName.toUpperCase()} - ${id}`} width={1} height={30} fontSize={14} />
  );
};

export default BarCode;
